import { ChildOrg, OrgByParent } from 'api/types/orgsApiTypes'
import { useUser } from 'contexts/UserContext'
import useFeatureFlags from 'hooks/feature-flags/useFeatureFlags'

export const useOrgDisplayWithSlug = () => {
  const { user } = useUser()
  const { shouldShowSlugInSelector } = useFeatureFlags()

  const userHasPermission = user?.isSuperAdmin || user?.isZeusITAdmin
  const shouldShowSlug = userHasPermission && shouldShowSlugInSelector

  const formatOrgDisplay = (org: OrgByParent | ChildOrg): string => {
    const displayName = org.org_display_name ?? org.org_name

    if (shouldShowSlug && org.org_slug) {
      return `${displayName} (${org.org_slug})`
    }

    return displayName
  }

  return { formatOrgDisplay, shouldShowSlug }
}
